import { Trans } from 'react-i18next'

import { TableColumnListValue } from '@makyoapp/makyo-common'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useAppAuthContext } from '@/context/__project__/AppAuthContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { ComponentSettingKey } from '@/shared/builder'

import { CompSingleRowWrapperCore } from '../core/single-row/wrapper'

/**
 * CompSingleRowWrapper
 */
function CompSingleRowWrapper() {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useCompBackgroundColor()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // actions
  const actionContext = useBuilderActionContextV2()

  // tableData
  const { dbClient, language, userSpecific, tablesMap } = useDbClientContext()
  const dataSource = compContext.settings?.[ComponentSettingKey.DataListData] as TableColumnListValue
  const tableId = dataSource?.table?.replace('__current_user', '') || ''
  const table = tableId ? tablesMap.get(tableId) : undefined

  // todo: error state
  if (!table || !dbClient) {
    return (
      <div className='flex justify-center items-center py-8'>
        <Trans>COMP_TABLE_NOT_FOUND</Trans>
      </div>
    )
  }

  return (
    <CompSingleRowWrapperCore
      infos={infosProps}
      action={actionContext}
      tableData={{ dbTable: table, dbClient, tableId, language, userSpecific }}
    />
  )
}

export default CompSingleRowWrapper
